import React from 'react';

export const SkeletonStatCard = () => (
  <div className="bg-white rounded-lg shadow p-5 animate-pulse">
    <div className="flex items-center justify-between">
      <div className="flex-1">
        <div className="h-3 bg-gray-200 rounded w-2/3 mb-3"></div>
        <div className="h-7 bg-gray-200 rounded w-1/3"></div>
      </div>
      <div className="h-11 w-11 rounded-full bg-gray-200"></div>
    </div>
  </div>
);

export const SkeletonBanner = () => (
  <div className="rounded-lg shadow-lg p-6 bg-gray-200 animate-pulse h-[118px]"></div>
);

export const SkeletonBlock = ({ rows = 4 }) => (
  <div className="bg-white rounded-lg shadow p-6 animate-pulse">
    <div className="h-4 bg-gray-200 rounded w-1/3 mb-4"></div>
    <div className="space-y-3">
      {Array.from({ length: rows }).map((_, i) => (
        <div key={i} className="h-4 bg-gray-200 rounded"></div>
      ))}
    </div>
  </div>
);

export const SkeletonTable = ({ rows = 5, cols = 6 }) => (
  <div className="p-6 animate-pulse">
    <div className="space-y-3">
      {Array.from({ length: rows }).map((_, r) => (
        <div key={r} className="flex gap-4">
          {Array.from({ length: cols }).map((_, c) => (
            <div key={c} className="h-4 bg-gray-200 rounded flex-1"></div>
          ))}
        </div>
      ))}
    </div>
  </div>
);
